export const ProgressRow = ({
  numOfColumns = 4,
  isFetching = false,
}: ProgressRowProps) => {
  return (
    <tr
      className={`w-full bg-gray-50 py-0 my-0 ${isFetching ? 'h-1.5' : 'h-0'}`}
      aria-hidden={!isFetching}
    >
      <td colSpan={numOfColumns} className="w-full p-0 border-0 leading-[0]">
        <div
          className={`w-full overflow-hidden bg-gray-50 ${
            isFetching ? 'h-1.5' : 'h-0'
          }`}
        >
          {isFetching && (
            <div className="progress w-full h-full bg-vi-red origin-left-right animate-progress z-10"></div>
          )}
        </div>
      </td>
    </tr>
  )
}

interface ProgressRowProps {
  numOfColumns: number
  isFetching: boolean
}
